module.exports = __webpack_public_path__ + "static/media/domain_icon.c74c18e4.svg";